import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { MAIN_ROUTE, ROUTES } from 'app/consts/constants';
import { EModuleIDs } from 'app/consts/enums';
import { SharedService } from 'app/services/shared.service';

@Injectable({ providedIn: 'root' })
export class DefaultRouteGuard implements CanActivate {
  constructor(
    private sharedService: SharedService,
    private router: Router,
  ) { }

  canActivate(): UrlTree {
    const target = this.sharedService.isIntellifleet ? EModuleIDs.SafetyReport : EModuleIDs.Manifests;
    return this.router.createUrlTree([MAIN_ROUTE, ROUTES[target]]);
  }
}
